export default __webpack_public_path__ + "static/media/linkedin.8b615aa7.png";